import { safeColor } from 'features/TeamChat/api/teamChat.transform'
import type { TeamUser } from 'features/TeamChat/api/teamChat.types'
import styles from 'features/TeamChat/teamChat.module.scss'

type AvatarSize = 24 | 28
type Props = { user: TeamUser; size?: AvatarSize }

// The design's initial sizes: 24px avatar -> 11px, 28px avatar -> 12px.
const INITIAL_FONT: Record<AvatarSize, number> = { 24: 11, 28: 12 }

// The avatar color is per-member data from the API.
export const MemberAvatar = ({ user, size = 24 }: Props) => (
  <span
    className={styles.avatar}
    aria-hidden='true'
    style={{
      width: size,
      height: size,
      fontSize: INITIAL_FONT[size],
      backgroundColor: safeColor(user.color, user.id),
    }}>
    {user.initial}
  </span>
)
